import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mutara-cart',
  template: `
  <mat-card>
  <form matForm #cartDialog>
      <mat-card-title><h1>{{title}}</h1></mat-card-title>
      <table>
        @for( classRecord of cartContents; track classRecord.className) {
      <tr>
      <td>{{classRecord.className}}</td>
      <td>{{classRecord.classCost}}</td>
      <td><mat-icon aria-label="Delete">close</mat-icon></td>
      </tr>
        } 
      </table>
  </form>
</mat-card>`,
  standalone: false
})

export class CartComponent implements OnInit {

  cartContents: any = {};
  title = 'Your Cart';
  cartCount: number = 0;

  /**
   * Class implementation
   * @param dialogRef 
   */
  constructor() { }

  ngOnInit() {
    // make call to get all classes in cart
    this.cartContents = [{}];
  }

}
